import { useCallback, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { headerData } from "../../data/headerCostum";
import { useNavigate } from "react-router-dom";
import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import SweetAlert2 from "react-sweetalert2";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessIcon from "@mui/icons-material/Business";
import HomeIcon from "@mui/icons-material/Home";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="darkslategray"
      align="center"
      {...props}
    >
      {"Copyright \u00a9 "}
      <Link color="inherit" href="https://diskominfo.makassarkota.go.id/">
        Diskominfo Kota Makassar
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#1dc39f',
    },
    secondary: {
      main: '#8ff9ab',
    },
  },
  typography: {
    h5: { fontWeight: 600 },
  },
});

const DaftarLongwisKeluhan = () => {
  const navigate = useNavigate();
  const [swalProps, setSwalProps] = useState({});
  const [currentStep, setCurrentStep] = useState(0);
  const [data, setData] = useState({
    id: null,
    kecamatan: null,
    kelurahan: null,
    longwis: null,
    alamat: null,
    nama_pic: '',
    kontak_pic: ''
  });

  const steps = ['Pilih Kecamatan', 'Pilih Kelurahan', 'Pilih Longwis', 'Pilih Alamat', 'Konfirmasi'];

  const [kecamatan, setKecamatan] = useState([{ id: 1, nama: 'Mohon Tunggu . . .' }])
  const [kelurahan, setKelurahan] = useState([{ id: 1, nama: 'Mohon Tunggu . . .' }])
  const [data_longwis, setDataLongwis] = useState([{ id: 1, nama: 'Mohon Tunggu . . .' }])
  const [data_alamat, setDataAlamat] = useState([{ id: 1, nama: 'Mohon Tunggu . . .' }])
  const [list_longwis, setListLongwis] = useState(null)

  const [openDialog, setOpenDialog] = useState(false);
  const handleOpenDialog = (event) => {
    event.preventDefault();
    setOpenDialog(true);
  };
  const handleCloseDialog = () => { setOpenDialog(false); };

  const getLongwisData = () => {
    fetch(process.env.REACT_APP_API_URL + "api/longwis", {
      method: "get",
      headers: headerData
    })
      .then((res) => {
        if (!res.ok) throw new Error('Gagal mengambil data longwis');
        return res.json();
      })
      .then((res) => {
        if (Array.isArray(res) && res.length > 0) {
          setListLongwis(res);
          getKecData(res)
        } else {
          setSwalProps({ show: true, title: "Gagal", icon: "error", text: "Data longwis tidak ditemukan atau kosong" });
        }
      })
      .catch((err) => {
        setSwalProps({ show: true, title: "Gagal", icon: "error", text: err.message || "Terjadi kesalahan saat mengambil data" });
      });
  }

  const getKecData = useCallback((data) => {
    let seen = [];
    let dataKecamatan = [];
    data.forEach((items, index) => {
      if (seen.includes(items.kecamatan)) return;
      seen.push(items.kecamatan)
      dataKecamatan.push({ nama: items.kecamatan, id: index });
    })
    setKecamatan(dataKecamatan)
  }, [])

  const kecHandle = useCallback((e) => {
    if (e) {
      const filteredData = [...list_longwis].filter(item => item.kecamatan === e.nama);
      let kel = [];
      let dataKel = [];
      filteredData.forEach((items, index) => {
        if (kel.includes(items.kelurahan)) return;
        kel.push(items.kelurahan)
        dataKel.push({ nama: items.kelurahan, id: index });
      })
      setKelurahan(dataKel);
      setDataLongwis([{ id: 1, nama: 'Pilih kelurahan terlebih dahulu' }]);
      setDataAlamat([{ id: 1, nama: 'Pilih longwis terlebih dahulu' }]);
      setData(prev => ({ ...prev, kecamatan: e, kelurahan: null, longwis: null, alamat: null, nama_pic: '', kontak_pic: '', id: null }));
      setCurrentStep(1);
    }
  }, [list_longwis]);

  const kelHandle = useCallback((e) => {
    if (e) {
      const filteredData = [...list_longwis].filter(item =>
        item.kecamatan === data.kecamatan?.nama && item.kelurahan === e.nama
      );
      let lw = [];
      let dataLw = [];
      filteredData.forEach((items, index) => {
        if (lw.includes(items.nama_longwis)) return;
        lw.push(items.nama_longwis)
        dataLw.push({ nama: items.nama_longwis, id: index });
      })
      setDataLongwis(dataLw);
      setDataAlamat([{ id: 1, nama: 'Pilih longwis terlebih dahulu' }]);
      setData(prev => ({ ...prev, kelurahan: e, longwis: null, alamat: null, nama_pic: '', kontak_pic: '', id: null }));
      setCurrentStep(2);
    }
  }, [list_longwis, data.kecamatan]);

  const alamatHandle = useCallback((selectedLongwis) => {
    if (selectedLongwis && data.kecamatan && data.kelurahan) {
      const filteredData = [...list_longwis].filter(item =>
        item.kecamatan === data.kecamatan.nama &&
        item.kelurahan === data.kelurahan.nama &&
        item.nama_longwis === selectedLongwis.nama
      );
      const dataAlamat = filteredData.map((items, index) => ({ nama: items.alamat, id: index }));
      setDataAlamat(dataAlamat);
      setData(prev => ({ ...prev, longwis: selectedLongwis, alamat: null }));
      setCurrentStep(3);
    }
  }, [list_longwis, data.kecamatan, data.kelurahan]);

  const finalizeSelection = useCallback((alamat) => {
    if (!alamat) return;
    const match = [...list_longwis].find(item =>
      item.kecamatan === data.kecamatan.nama &&
      item.kelurahan === data.kelurahan.nama &&
      item.nama_longwis === data.longwis.nama &&
      item.alamat === alamat.nama
    );
    if (match) {
      setData(prev => ({
        ...prev,
        id: match.id,
        alamat: alamat,
        nama_pic: match.nama_pic || '',
        kontak_pic: match.kontak_pic || ''
      }));
      setCurrentStep(4);
    }
  }, [list_longwis, data.kecamatan, data.kelurahan, data.longwis]);

  const goToKeluhanForm = () => {
    if (!data.id) {
      setSwalProps({ show: true, title: "Error", icon: "error", text: "Pilih data lengkap terlebih dahulu" });
      return;
    }
    navigate("/pic/keluhan", {
      state: {
        data_longwis: {
          id: data.id,
          nama_lokasi: `${data.longwis?.nama} - ${data.alamat?.nama}`,
          kecamatan: data.kecamatan?.nama,
          kelurahan: data.kelurahan?.nama,
          nama_longwis: data.longwis?.nama,
          alamat: data.alamat?.nama,
          nama_pic: data.nama_pic,
          kontak_pic: data.kontak_pic,
        },
      },
    });
    setOpenDialog(false);
  };

  useEffect(() => { if (!list_longwis) getLongwisData(); }, [list_longwis]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1dc39f 0%, #8ff9ab 100%)',
        py: 3
      }}
    >
      <ThemeProvider theme={defaultTheme}>
        <Container component="main" maxWidth="md">
          <CssBaseline />
          <SweetAlert2 {...swalProps} didClose={() => setSwalProps({})} />

          <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
            <DialogTitle align="center" sx={{ bgcolor: 'primary.main', color: 'white' }}>
              Konfirmasi Data
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
              <DialogContentText sx={{ mb: 2 }}>
                Pastikan data yang dipilih sudah benar:
              </DialogContentText>
              <Box sx={{ pl: 2 }}>
                <Typography variant="body2" sx={{ mb: 1 }}><strong>Kecamatan:</strong> {data.kecamatan?.nama || '-'}</Typography>
                <Typography variant="body2" sx={{ mb: 1 }}><strong>Kelurahan:</strong> {data.kelurahan?.nama || '-'}</Typography>
                <Typography variant="body2" sx={{ mb: 1 }}><strong>Longwis:</strong> {data.longwis?.nama || '-'}</Typography>
                <Typography variant="body2" sx={{ mb: 1 }}><strong>Alamat:</strong> {data.alamat?.nama || '-'}</Typography>
                <Typography variant="body2" sx={{ mb: 1 }}><strong>PIC:</strong> {data.nama_pic || '-'}</Typography>
                <Typography variant="body2"><strong>Kontak PIC:</strong> {data.kontak_pic || '-'}</Typography>
              </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "space-between", p: 3 }}>
              <Button variant="outlined" onClick={handleCloseDialog} sx={{ borderColor: 'error.main', color: 'error.main', '&:hover': { borderColor: 'error.dark', backgroundColor: 'error.light' } }}>Kembali</Button>
              <Button variant="contained" onClick={goToKeluhanForm} autoFocus sx={{ background: 'linear-gradient(90deg, #1dc39f, #8ff9ab)', '&:hover': { background: 'linear-gradient(90deg, #17a085, #7ce89a)' } }}>Lanjutkan</Button>
            </DialogActions>
          </Dialog>

          <Paper elevation={10} sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: 3, background: 'rgba(255, 255, 255, 0.95)', backdropFilter: 'blur(10px)' }}>
            <Box sx={{ width: 80, height: 80, borderRadius: '50%', backgroundColor: 'primary.main', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2, boxShadow: 3 }}>
              <LocationOnIcon sx={{ fontSize: 40, color: 'white' }} />
            </Box>
            <Typography component="h1" variant="h5" sx={{ mb: 1, color: 'primary.main' }}>Pilih Lokasi Keluhan</Typography>
            <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary', textAlign: 'center' }}>Pilih lokasi Longwis untuk membuat keluhan</Typography>

            <Box sx={{ width: '100%', mb: 4 }}>
              <Stepper activeStep={currentStep} alternativeLabel>
                {steps.map((label) => (
                  <Step key={label}><StepLabel>{label}</StepLabel></Step>
                ))}
              </Stepper>
            </Box>

            <Box component="form" onSubmit={(e)=>{e.preventDefault(); setOpenDialog(true)}} sx={{ width: '100%', maxWidth: 600 }}>
              <Card sx={{ mb: 3, border: '1px solid', borderColor: currentStep >= 0 ? 'primary.main' : 'grey.300' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <BusinessIcon color={currentStep >= 0 ? 'primary' : 'disabled'} sx={{ mr: 1 }} />
                    <Typography variant="h6">Kecamatan</Typography>
                  </Box>
                  <Autocomplete
                    disablePortal
                    id="kecamatan"
                    options={kecamatan || [{ nama: "Loading..." }]}
                    value={data.kecamatan}
                    getOptionLabel={(option) => option.nama}
                    onChange={(event, newValue) => { kecHandle(newValue); }}
                    fullWidth
                    renderInput={(params) => (<TextField {...params} fullWidth placeholder="Pilih Kecamatan" variant="outlined" />)}
                  />
                </CardContent>
              </Card>

              <Card sx={{ mb: 3, border: '1px solid', borderColor: currentStep >= 1 ? 'primary.main' : 'grey.300' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <HomeIcon color={currentStep >= 1 ? 'primary' : 'disabled'} sx={{ mr: 1 }} />
                    <Typography variant="h6">Kelurahan</Typography>
                  </Box>
                  <Autocomplete
                    disablePortal
                    id="kelurahan"
                    options={kelurahan || [{ id: 1, nama: "Pilih kecamatan terlebih dahulu" }]}
                    value={data.kelurahan}
                    getOptionLabel={(option) => option.nama}
                    onChange={(event, newValue) => { kelHandle(newValue); }}
                    disabled={!data.kecamatan}
                    fullWidth
                    renderInput={(params) => (<TextField {...params} fullWidth placeholder="Pilih Kelurahan" variant="outlined" />)}
                  />
                </CardContent>
              </Card>

              <Card sx={{ mb: 3, border: '1px solid', borderColor: currentStep >= 2 ? 'primary.main' : 'grey.300' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <LocationOnIcon color={currentStep >= 2 ? 'primary' : 'disabled'} sx={{ mr: 1 }} />
                    <Typography variant="h6">Nama Longwis</Typography>
                  </Box>
                  <Autocomplete
                    disablePortal
                    id="longwis"
                    options={data_longwis || [{ id: 1, nama: "Pilih kelurahan terlebih dahulu" }]}
                    value={data.longwis}
                    getOptionLabel={(option) => option.nama}
                    onChange={(event, newValue) => { setData(prev=>({...prev,longwis:newValue})); alamatHandle(newValue); }}
                    disabled={!data.kelurahan}
                    fullWidth
                    renderInput={(params) => (<TextField {...params} fullWidth placeholder="Pilih Nama Lorong Wisata" variant="outlined" />)}
                  />
                </CardContent>
              </Card>

              <Card sx={{ mb: 3, border: '1px solid', borderColor: currentStep >= 3 ? 'primary.main' : 'grey.300' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <HomeIcon color={currentStep >= 3 ? 'primary' : 'disabled'} sx={{ mr: 1 }} />
                    <Typography variant="h6">Alamat Longwis</Typography>
                  </Box>
                  <Autocomplete
                    disablePortal
                    id="alamat_longwis"
                    options={data_alamat || [{ id: 1, nama: "Pilih longwis terlebih dahulu" }]}
                    value={data.alamat}
                    getOptionLabel={(option) => option.nama}
                    onChange={(event, newValue) => { finalizeSelection(newValue); }}
                    disabled={!data.longwis}
                    fullWidth
                    renderInput={(params) => (<TextField {...params} fullWidth placeholder="Pilih Alamat Lorong Wisata" variant="outlined" />)}
                  />
                </CardContent>
              </Card>

              <Button type="submit" fullWidth variant="contained" disabled={currentStep < 4}
                sx={{ py: 1.5, fontSize: '1.1rem', fontWeight: 600, borderRadius: 2, background: currentStep >= 4 ? 'linear-gradient(90deg, #1dc39f, #8ff9ab)' : 'grey.400', textTransform: 'none', '&:hover': { background: currentStep >= 4 ? 'linear-gradient(90deg, #17a085, #7ce89a)' : 'grey.500' } }}>
                {currentStep >= 4 ? 'Lanjut ke Form Keluhan' : 'Lengkapi Data Terlebih Dahulu'}
              </Button>
            </Box>

            <Copyright sx={{ mt: 4 }} />
          </Paper>
        </Container>
      </ThemeProvider>
    </Box>
  );
};

export default DaftarLongwisKeluhan;
